export const SET_USERNAME = "SET_USERNAME";
export const SET_TOKEN = "SET_TOKEN";
export const SET_LOADING = "SET_LOADING";



// WEBPACK FOOTER //
// ./src/store/mutation-types.js